import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { appBootstrap } from '@unpispas/upp-base';
import { AppModule } from './app/app.module';

console.info(`[BOOT] main +${Math.round(performance.now())}ms`);

const SPLASH_MAX_WAIT_MS = 20000;

function clearSplashscreen(): void {
    const splash = document.getElementById('splashscreen');
    if (splash) {
        splash.remove();
    }
}

/**
 * Keeps the splash visible until the application signals ready (or the safety
 * timeout elapses), then clears it after the browser paints the first screen.
 */
function clearSplashWhenReady(): void {
    let done = false;
    const finish = (): void => {
        if (done) {
            return;
        }
        done = true;
        window.clearTimeout(hardTimeout);
        requestAnimationFrame(() => requestAnimationFrame(clearSplashscreen));
    };

    const hardTimeout = window.setTimeout(finish, SPLASH_MAX_WAIT_MS);
    appBootstrap.OnReady.then(finish);
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        ngZoneEventCoalescing: true,
    })
    .then(() => {
        clearSplashWhenReady();
    })
    .catch((err) => {
        clearSplashscreen();
        console.error(err);
    });
